import { useState } from 'react';
import { toast } from 'react-toastify';
import { useUnitAreaAssets } from 'src/services/api/UnitAreaAssets/hooks/useUnitAreaAssets';
import { changeServiceRequestAsset } from 'src/services/client';
import { IUnitAreaAsset } from 'src/services/api/UnitAreaAssets/apiContracts';

export interface UseChangeAssetAPIReturn {
  isOpen: boolean;
  isSubmitting: boolean;
  unitAreaAssets: IUnitAreaAsset[];
  isFetchingAssets: boolean;
  openDialogue: (suiteId: string) => void;
  closeDialogue: () => void;
  handleChangeAsset: (
    serviceRequestId: string,
    assetId: string
  ) => Promise<boolean>;
}

export const useChangeAssetAPI = (): UseChangeAssetAPIReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    unitAreaAssets,
    fetchData,
    loading: isFetchingAssets,
  } = useUnitAreaAssets();

  const openDialogue = (suiteId: string) => {
    setIsOpen(true);
    fetchData(suiteId);
  };

  const closeDialogue = () => {
    setIsOpen(false);
  };

  const handleChangeAsset = async (
    serviceRequestId: string,
    assetId: string
  ): Promise<boolean> => {
    setIsSubmitting(true);
    try {
      const response: any = await changeServiceRequestAsset(
        serviceRequestId,
        assetId
      );

      if (!response?.ok && response?.status !== 200) {
        toast.error('Failed to update asset. Please try again.', {
          autoClose: 5000,
          position: 'top-center',
        });
        return false;
      }

      toast.success('Asset updated successfully.', {
        autoClose: 3000,
        position: 'top-center',
      });

      setIsOpen(false);
      return true;
    } catch (error) {
      console.error('Error changing service request asset:', error);
      toast.error('Failed to update asset. Please try again.', {
        autoClose: 5000,
        position: 'top-center',
      });

      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isOpen,
    isSubmitting,
    unitAreaAssets,
    isFetchingAssets,
    openDialogue,
    closeDialogue,
    handleChangeAsset,
  };
};
